import { render, staticRenderFns } from "./CommissionSettingsDataTable.vue?vue&type=template&id=59ba7a48"
import script from "./CommissionSettingsDataTable.vue?vue&type=script&lang=js"
export * from "./CommissionSettingsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports